/**
 * Created by ptdave on 6/22/17.
 */
import {Component, Input} from '@angular/core';
import {StudentService} from '../../services/student.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {formatDate} from '../../date.prototype';
import {DistrictService} from '../../services/district.service';
import {Level, ToastService} from '../../services/toast.service';
import {StaffDto} from '../../common/dtos/staffDto';
import {StaffButtonSelectDialogComponent} from '../../components/main/staffButton.component';
import {NgForm} from '@angular/forms';
import {ContactLogDto} from '@sidr/dto-types';

@Component({
  selector: `student-contact-dialog`,
  templateUrl: 'student-contact-dialog.html'
})
export class StudentContactDialog {
  editContact: any;
  @Input() contact: ContactLogDto;
  @Input() edit: boolean;
  @Input() studentId: string;
  @Input() districtId: string;
  @Input() staff: StaffDto[];
  staffOpened: boolean;

  NotificationTitle = 'Communication';

  constructor(
    public activeModal: NgbActiveModal,
    public studentService: StudentService,
    public districtService: DistrictService,
    private modalService: NgbModal,
    private toastService: ToastService) {
    this.edit = false;
    this.editContact = {
      date: new Date()
    };
    this.contact = {
      date: '',
      assess_shared: '',
      type: '',
      outcome: '',
      importTag: '',
      staff_name: '',
      info_shared: ''
    }
  }

  selectStaff() {
    this.staffOpened = true;
    const modal = this.modalService.open(StaffButtonSelectDialogComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true
    });

    this.districtService.getBuildings(this.districtId).subscribe(resp => {
      modal.componentInstance.buildings = resp;
    });

    modal.componentInstance.selected = this.contact.staff_id;
    modal.componentInstance.district_id = this.districtId;
    modal.componentInstance.districtId = this.districtId;
    modal.componentInstance.multiple = false;

    modal.result.then((resp) => {
      this.editContact.staff_id = resp;
    }, (resp) => {

    });
  }

  markEditContact() {
    this.edit = true;
    this.editContact = this.contact;
    this.editContact.date = formatDate(this.contact.date);
  }

  closeWindow() {
    if (this.edit) {
      this.activeModal.close('cancelled');
    } else {
      this.activeModal.dismiss();
    }
  }

  save(form: NgForm) {
    if (form.errors) {
      console.log(form.errors);
      return;
    }

    (this.contact.id ?
      this.studentService.patchContact(this.districtId, this.studentId, this.editContact) :
      this.studentService.postContact(this.districtId, this.studentId, this.editContact))
      .subscribe(resp => {
        this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Contact saved');
        this.activeModal.close(resp);
      }, (err) => {
        this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Error saving contact');
      });
  }
}
